export const pinnedElement = (quotes) => {
  const quote = quotes.find(({ pinned }) => !!pinned);
  return { hasPinnedElement: !!quote, quote };
};
